var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-popup',{attrs:{"active":_vm.$props.popupActive,"title":"Annonce"},on:{"update:active":function($event){return _vm.$set(_vm.$props, "popupActive", $event)}}},[_vm._v("\n    "+_vm._s(_vm.notice.notice)+"\n         ")])
}
var staticRenderFns = []

export { render, staticRenderFns }